import * as _secp256k2 from "@noble/curves/secp256k1";
var _secp256k = _secp256k2;
try {
  if ("default" in _secp256k2) _secp256k = _secp256k2.default;
} catch (e) {}
import { dew as _toHexDew } from "../../utils/encoding/toHex.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.hexToSignature = void 0;
  const secp256k1_1 = _secp256k;
  const toHex_js_1 = _toHexDew();
  function hexToSignature(signatureHex) {
    const {
      r,
      s
    } = secp256k1_1.secp256k1.Signature.fromCompact(signatureHex.slice(2, 130));
    const v = BigInt(`0x${signatureHex.slice(130)}`);
    return {
      r: (0, toHex_js_1.numberToHex)(r, {
        size: 32
      }),
      s: (0, toHex_js_1.numberToHex)(s, {
        size: 32
      }),
      v
    };
  }
  exports.hexToSignature = hexToSignature;
  //# sourceMappingURL=hexToSignature.js.map
  return exports;
}